import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from 'react-bootstrap';
import config from './config.json';

const Step5 = ({ prevStep, nextStep }) => {
const currentStep = 5;
  const heating_energy = localStorage.getItem("heating_energy");

  const [oil_type, setOilType] = useState('');
  const [electric_type, setElectricType] = useState('');
  const [gas_type, setGasType] = useState('');

  const storedValue = localStorage.getItem('oil_type');
  const storedValue2 = localStorage.getItem('electric_type');
  const storedValue3 = localStorage.getItem('gas_type');

  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true); // Nouvelle variable d'état

  useEffect(() => {
    // Récupère la valeur du localStorage lors du chargement initial du composant

    if (storedValue) {
     setOilType(storedValue);
    }
    if(storedValue2) {  
      setElectricType(storedValue2);
     }
     if(storedValue3) {  
      setGasType(storedValue3);
     }
  }, [storedValue, storedValue2, storedValue3]);

  useEffect(() => {
    if (heating_energy === 'fioul' && !oil_type) {
      setSubmitButtonDisabled(true);
    } else if (heating_energy === 'electrique' && !electric_type) {
      setSubmitButtonDisabled(true);
    }
      else if (heating_energy === 'gaz' && !gas_type) {
      setSubmitButtonDisabled(true);
    } else {
      setSubmitButtonDisabled(false);
    }
  }, [heating_energy, oil_type, electric_type, gas_type]);

  const handleChange = (event) => {
    const { value } = event.target;
    setOilType(value);
    localStorage.setItem('oil_type', value); // Ajout de la sauvegarde dans le local storage
    nextStep();
  };

  const handleChange2 = (event) => {
    const { value } = event.target;
    setElectricType(value);
    localStorage.setItem('electric_type', value); // Ajout de la sauvegarde dans le local storage
    nextStep();
  };

  const handleChange3 = (event) => {
    const { value } = event.target;
    setGasType(value);
    localStorage.setItem('gas_type', value); // Ajout de la sauvegarde dans le local storage
    nextStep();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    nextStep();
  };

  const renderOptions = () => {
    switch (heating_energy) {
      case 'fioul':
        return (
          <div>
            <Row className="mb-3 container-bloc">
              {[
                { label: 'Chaudière à condensation', value: 'chaudiere_a_condensation', image:  `${config.linkImage}${config.step5.image1}` },
                { label: 'Chaudière classique', value: 'chaudiere_classique', image:  `${config.linkImage}${config.step5.image2}`  },
                { label: 'Poêle', value: 'poele', image:  `${config.linkImage}${config.step5.image3}`  },
              ].map(({ label, value, image }, index) => (
                <Col
                  key={index}
                  className={`m-2 icon-container ${oil_type === value ? 'selected' : ''}`}
                >
                  <label>
                    <input
                      type="radio"
                      value={value}
                      checked={oil_type === value}
                      onChange={handleChange}
                      className="d-none"
                    />
                    <div>
                      <img src={image} className="size-img" />
                      <p>{label}</p>
                    </div>
                  </label>
                </Col>
              ))}
            </Row>
          </div>
        );
      case 'electrique':
        return ( 
          <div>   
            <Row className="mb-3 container-bloc">
              {[
                { label: 'Chaudière électrique', value: 'chaudiere_electrique', image: `${config.linkImage}${config.step5.image4}` },
                { label: 'Plafonds ou planchers chauffants', value: 'plafonds_ou_planchers_chauffants', image: `${config.linkImage}${config.step5.image5}` },
                { label: 'Radiateurs électriques', value: 'radiateurs_electriques', icon: '', image: `${config.linkImage}${config.step5.image6}` },
              ].map(({ label, value, image }, index) => (
                <Col
                  key={index}
                  className={`m-2 icon-container ${electric_type === value ? 'selected' : ''}`}
                >
                  <label>
                    <input
                      type="radio"
                      value={value}
                      checked={electric_type === value}
                      onChange={handleChange2}
                      className="d-none"
                    />
                    <div>
                      <img src={image} className="size-img" />
                      <p>{label}</p>
                    </div>
                  </label>
                </Col>
              ))}
            </Row>
          </div>
        );
      case 'gaz':
        return (   
          <div>  
            <Row className="mb-3 justify-content-center">
              {[
                { label: 'Chaudière à condensation', value: 'chaudiere_a_condensation', image: `${config.linkImage}${config.step5.image7}` },
                { label: 'Chaudière classique', value: 'chaudiere_classique', image: `${config.linkImage}${config.step5.image8}` },
                { label: 'Radiateur au gaz', value: 'radiateur_au_gaz', image: `${config.linkImage}${config.step5.image9}` },
                { label: 'Poêle au gaz', value: 'poele_au_gaz', image: `${config.linkImage}${config.step5.image10}` },
              ].map(({ label, value, image }, index) => (
                <Col
                  key={index}
                  className={`m-2 icon-container ${gas_type === value ? 'selected' : ''}`}
                >
                  <label>
                    <input
                      type="radio"
                      value={value}
                      checked={gas_type === value}
                      onChange={handleChange3}
                      className="d-none"
                    />
                    <div>
                      <img src={image} className="size-img" />
                      <p>{label}</p>
                    </div>
                  </label>
                </Col>
              ))}
            </Row>
          </div> 
        );
      default:
        return null;
    }
  };

  return (
    <Container>
      <ProgressBar
        now={(currentStep / 36) * 100}
        style={{ backgroundColor: "#bad7f1" }}
      >
      <ProgressBar
        now={(currentStep / 36) * 100}
        style={{ backgroundColor: "#0be288" }}
      />
      </ProgressBar>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
            <Col>
                <h2>{config.step5.step}</h2>
                <h3>{config.step5.title}</h3>
                <p></p>
            </Col>
        </Row>
        <Row className="mb-3 justify-content-center">
          <Col>{renderOptions()}</Col>
        </Row>
        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
            <Button type="button" variant="secondary" onClick={prevStep}>
              Précédent
            </Button>
            <Button type="submit" variant="primary" className="ms-3" disabled={submitButtonDisabled}>
              Suivant
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step5;
